import { NgModule } from '@angular/core';
import { IonicPageModule } from 'ionic-angular';
import { HousingUnitIndexPage } from './housing-unit-index';
import { ComponentsModule } from '../../components/components.module';

@NgModule({
	declarations: [
		HousingUnitIndexPage,
	],
	imports: [
		ComponentsModule,
		IonicPageModule.forChild(HousingUnitIndexPage),
	],
})
export class HousingUnitIndexPageModule { }



// WEBPACK FOOTER //
// ./src/pages/housing-unit-index/housing-unit-index.module.ts